<header class="page-header">
	<h2>Users</h2>
</header>

<div class="flex justify-between items-center flex-wrap mb-6 mt-10">
	<div class="flex items-center">
		<app-input
			class="max-w-350 w-full"
			placeholder="Search for a user"
			[startIcon]="icon.SEARCH"
			(debounce)="applyFilter()"
			[(ngModel)]="filter.search"
		></app-input>
	</div>
	<div class="flex flex-row gap-x-10 items-center flex-wrap">
		<div class="flex flex-row gap-2 items-center">
			<app-pill
				[mode]="filter.role === roleFilterItem ? 'primary' : 'secondary'"
				class="cursor-pointer select-none"
				size="small"
				(click)="changeRoleFilter(roleFilterItem)"
				*ngFor="let roleFilterItem of roleFilterItems"
			>
				{{ roleFilterItem | capitalize }}
			</app-pill>
		</div>
		<ng-container *ngIf="!loadedFromLeap">
			<app-radio-group
				[items]="statusItems"
				type="pill"
				[(ngModel)]="filter.status"
				(ngModelChange)="applyFilter()"
			></app-radio-group>
			<app-button
				cssClasses="button h-10"
				btn="primary"
				[icon]="icon.ADD"
				(onClick)="openInvitesModal()"
				intercomAttr="users-invite-colleagues-btn"
				>Invite colleagues</app-button
			>
		</ng-container>
	</div>
</div>

<table
	mat-table
	[trackBy]="trackById"
	[dataSource]="dataSource"
	matSort
	class="app-table animate w-full overflow-hidden rounded"
>
	<ng-container matColumnDef="fullNameLowercase">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
		<td mat-cell *matCellDef="let element">{{ element.fullName }}</td>
	</ng-container>

	<ng-container matColumnDef="emailLowercase">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
		<td mat-cell *matCellDef="let element">{{ element.email }}</td>
	</ng-container>

	<ng-container matColumnDef="role">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
		<td mat-cell *matCellDef="let element">
			<app-select
				[(ngModel)]="element.role"
				(ngModelChange)="setRole(element.id, $event)"
			>
				<option [value]="roles.LAWYER">Lawyer</option>
				<option [value]="roles.CLERK">Clerk</option>
				<option [value]="roles.OTHER">Other</option>
			</app-select>
		</td>
	</ng-container>

	<ng-container matColumnDef="restricted">
		<th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="">
			<span class="flex gap-2">
				Restricted view
				<app-icon
					[icon]="icon.INFO_SQUARE"
					matTooltip="Restricts a user to only view their assigned matters"
				></app-icon>
			</span>
		</th>
		<td mat-cell *matCellDef="let element">
			<div class="flex" *ngIf="element.role !== roles.OTHER">
				<atomic-switch
					[matTooltip]="
						element.restricted
							? 'User can only view their assigned matters'
							: 'User can see all matters'
					"
					[ngModel]="element.restricted"
					(ngModelChange)="
						setRestricted(
							element.id,
							$event,
							[element.firstName, element.lastName].join(' ')
						)
					"
				></atomic-switch>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="admin">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			<span class="flex gap-2">
				Admin
				<app-icon
					[icon]="icon.INFO_SQUARE"
					matTooltip="Enables a user to view and edit business settings"
				></app-icon>
			</span>
		</th>
		<td mat-cell *matCellDef="let element">
			<div class="flex">
				<atomic-switch
					[ngModel]="element.admin"
					[disabled]="element.id === userId"
					(ngModelChange)="
						setAdmin(
							element.id,
							$event,
							[element.firstName, element.lastName].join(' ')
						)
					"
				></atomic-switch>
			</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="actions">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let element">
			<app-button
				*ngIf="element.status.trim() === statuses.ACTIVE"
				size="small"
				(onClick)="openRemoveModal(element)"
				btn="tertiary"
				[disabled]="element.id === userId"
				>Deactivate</app-button
			>
			<app-button
				*ngIf="element.status.trim() === statuses.INACTIVE"
				size="small"
				(onClick)="reAdd(element)"
				btn="tertiary"
				[disabled]="element.id === userId"
				holdLabel="activate"
				[holdable]="true"
				[loading]="addingRemovingUser === element.id"
				>Activate</app-button
			>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		class="animate"
	></tr>
	<tr class="mat-row" *matNoDataRow>
		<td
			class="mat-cell"
			[attr.colspan]="displayedColumns.length"
			class="text-center text-grey"
		>
			Sorry, no users found. Please try again!
		</td>
	</tr>
</table>
